import { render } from "./ButtonLink.vue?vue&type=template&id=0f7dc922&scoped=true&ts=true"
import script from "./ButtonLink.ts?vue&type=script&lang=ts"
export * from "./ButtonLink.ts?vue&type=script&lang=ts"

import "./ButtonLink.scss?vue&type=style&index=0&id=0f7dc922&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f7dc922"]])

export default __exports__